import { leaderboardQueryOptions } from '@/api/queries/leaderboard';
import { LeaderboardScreen } from '@/features/leaderboard/leaderboard-screen';
import type { LeaderboardCategory } from '@/types/leaderboard';
import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';

export default function LeaderboardRoute() {
  const [category, setCategory] = useState<LeaderboardCategory>('check_ins');
  const { data, isLoading } = useQuery(leaderboardQueryOptions(category));

  return (
    <LeaderboardScreen
      entries={data?.entries ?? []}
      currentUser={data?.currentUser ?? null}
      category={category}
      onCategoryChange={setCategory}
      isLoading={isLoading}
    />
  );
}
